export default __webpack_public_path__ + "static/media/25220e734dece026.e2d46d9b41562bf5289b955dc8bd2fdb.svg";